<form [formGroup]="updateEmailForm" class="flex flex-col gap-1">
    <p class="font-bold">Email Address</p>
    <div class="flex flex-row gap-2">
        <input formControlName="email" class="p-1 bg-slate-100 rounded-sm shadow-sm grow disabled:text-slate-400">
        <button (click)="onChangeEmailClicked()" class="w-[8ch] p-1 bg-slate-100 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" [disabled]="!canSubmitEmailChange()">
            @if (!isUpdating) {
                Change
            } @else {
                <busy-spin [small]="true"></busy-spin>
            }
        </button>
    </div>
    <p class="text-xs text-slate-400">
        Used to login and for password recovery.
    </p>
</form>